import { gql } from "apollo-angular";

export const BULK_CREATE_ATTENDANCE = gql`
  mutation bulkCreateAttendances($file: Upload!) {
    bulkCreateAttendances(file: $file)
  }
`;

export const EXPORT_ATTENDANCE = gql`
  mutation exportUnverifiedAttendance($date: String!) {
    exportUnverifiedAttendance(date: $date)
  }
`;

export const MARK_AS_HALFDAY = gql`
  mutation markAsHalfDay($id: Int!, $employeeId: Int!) {
    markAsHalfDay(id: $id, employeeId: $employeeId){
    id
    isVerified
    isHalfDay
    isOnLeave
    isOffDay
  }
  }
`;

export const MARK_AS_CONSIDERABLE = gql`
  mutation markAsConsiderable($id: Int!, $employeeId: Int!) {
    markAsConsiderable(id: $id, employeeId: $employeeId){
    id
    isVerified
    isHalfDay
    isOnLeave
    isOffDay
  }
  }
`;
export const MARK_AS_LOP = gql`
  mutation markAsLossOfPay($id: Int!, $employeeId: Int!) {
    markAsLossOfPay(id: $id, employeeId: $employeeId){
    id
    isVerified
    isHalfDay
    isOnLeave
    isOffDay
  }
  }
`;